import CitySEOHead from "@/components/feature/CitySEOHead";
import SiouxCityHeroSection from "./components/HeroSection";
import SiouxCityStickyNav from "./components/StickyNav";
import SiouxCityProcessingTimeSection from "./components/ProcessingTimeSection";
import SiouxCityServicesSection from "./components/ServicesSection";
import SiouxCityLocalAreaSection from "./components/LocalAreaSection";
import SiouxCityTestimonialsSection from "./components/TestimonialsSection";
import SiouxCityAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import SiouxCityComparisonSection from "./components/ComparisonSection";
import SiouxCityMistakesSection from "./components/MistakesSection";
import SiouxCityHowItWorksSection from "./components/HowItWorksSection";
import SiouxCityFAQSection, { faqs } from "./components/FAQSection";
import SiouxCityHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import SiouxCityFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function SiouxCityPage() {
  return (
    <>
      <CitySEOHead
        city="Sioux City"
        state="Iowa"
        stateAbbr="IA"
        route="/cities/sioux-city"
        title="Emergency Passport Sioux City, IA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Sioux City, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Woodbury County, the Tri-State area, Western Iowa families, National Guard members, and business travelers."
        geoPlacename="Sioux City, Iowa"
        geoPosition="42.4999;-96.4003"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Iowa"
        statePageRoute="/states/iowa"
      />
      <div className="font-sans">
        <SiouxCityHeroSection />
        <SiouxCityStickyNav />
        <SiouxCityProcessingTimeSection />
        <SiouxCityServicesSection />
        <SiouxCityLocalAreaSection />
        <SiouxCityTestimonialsSection />
        <SiouxCityAcceptanceFacilitiesSection />
        <SiouxCityComparisonSection />
        <SiouxCityMistakesSection />
        <SiouxCityHowItWorksSection />
        <SiouxCityFAQSection />
        <SiouxCityHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/sioux-city" state="IA" />
        <SiouxCityFinalCTA />
      </div>
    </>
  );
}